import { RedoFulfillmentToteSchema } from "@redotech/redo-fulfillment-group-common/fulfillment-tote";
import { locationIdFormat } from "@redotech/redo-ids-cockroach";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const updateTote = {
  name: "updateTote" as const,
  input: z.object({
    toteId: zExt.objectId(),
    name: z.string().optional(),
    toteGroupId: zExt.objectId().nullish(),
    locationId: locationIdFormat.schema.nullish(),
  }),
  output: RedoFulfillmentToteSchema,
};
